import styled from 'styled-components';

export const BundleTagContainer = styled.div`
    background: ${({ containerBackground }) =>
        containerBackground ? containerBackground : '#f2efff'};
    border: ${({ continerBorder }) =>
        continerBorder ? continerBorder : '0.5px solid #c0b2ff'};
    border-radius: ${({ containerBorderRadius }) =>
        containerBorderRadius ? containerBorderRadius : '4px'};

    width: ${({ containerWidth }) =>
        containerWidth ? containerWidth : '59px'};
    height: ${({ containerHeight }) =>
        containerHeight ? containerHeight : '18px'};
    margin: ${({ containerMargin }) =>
        containerMargin ? containerMargin : '0'};
    opacity: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left:5px;
     @media (min-width: 768px) and (max-width: 1200px) {
        width: 20px; margin-right: 2%;
        padding: 2%;
    }
`;

export const BundleTagFont = styled.p`
    margin: ${({ margin }) => (margin ? margin : '0')};
    display: inline-block;
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Bold'};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '10px')};
    color: ${({ color }) => (color ? color : '#654ADC')};
    text-decoration: ${({ textDecoration }) =>
        textDecoration ? textDecoration : 'none'};
    letter-spacing: ${({ letterSpacing }) =>
        letterSpacing ? letterSpacing : '0px'};
    line-height: ${({ lineHeight }) => (lineHeight ? lineHeight : '20px')};
    padding: ${({ padding }) => (padding ? padding : '0rem')};
    opacity: ${({ opacity }) => (opacity ? opacity : 1)};
    text-transform: ${({ textTrasnform }) =>
        textTrasnform ? textTrasnform : 'none'};
`;
